"use client";

import { useCallback, useMemo } from "react";
import { parseAsString } from "nuqs";
import { ArbiAcademyModal } from "@/components/ui/arbi-academy-modal";
import { useQuerySearchParams } from "@/hooks/use-query-search-params";
import { PROJECTS_ACADEMY_CONTENT } from "../lib/projects";

const PROJECTS_ACADEMY_QUERY = {
  field: "projects_academy",
  parser: parseAsString.withDefault(""),
} as const;

export function useOpenProjectsAcademy() {
  const [, setParam] = useQuerySearchParams(PROJECTS_ACADEMY_QUERY);
  return useCallback(() => {
    setParam("true", { history: "replace", scroll: false });
  }, [setParam]);
}

export function ProjectsAcademyModal() {
  const [raw, setParam] = useQuerySearchParams(PROJECTS_ACADEMY_QUERY);
  const open = useMemo(() => raw === "true", [raw]);

  const onClose = useCallback(() => {
    setParam(null, { history: "replace", scroll: false });
  }, [setParam]);

  return (
    <ArbiAcademyModal
      open={open}
      onClose={onClose}
      content={PROJECTS_ACADEMY_CONTENT}
    />
  );
}
